import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { BaseURL } from '../../../../../base/env';
import styles from '../Banner.module.css';
import DoubleBannerWrapper from './DoubleBannerWrapper';

const DoubleBanners = ({ data, setProductModalData, showModal_visible }) => {
  const history = useHistory();

  return (
    <div className={styles.BannerContainer}>
      <DoubleBannerWrapper
        className={styles.Left}
        code={data.design1.code}
        color={data.design1.color}
        ended_at={data.ended_at1}
        external_url={data.url}
        image_url={BaseURL + data.image}
        is_active={data.counter_is_active1}
        is_external_url={data.external_url}
        now={data.now}
        onClick={() => {
          if (data.product) {
            setProductModalData(data.product);
            showModal_visible(true);
          } else if (data.url) {
            history.push(data.url);
          }
        }}
        position={data.design1.position}
        started_at={data.started_at1}
      />
      <DoubleBannerWrapper
        className={styles.Right}
        code={data.design2.code}
        color={data.design2.color}
        ended_at={data.ended_at2}
        external_url={data.url_2}
        image_url={BaseURL + data.image_2}
        is_active={data.counter_is_active2}
        is_external_url={data.external_url_2}
        now={data.now}
        onClick={() => {
          if (data.product_2) {
            setProductModalData(data.product_2);
            showModal_visible(true);
          } else if (data.url_2) {
            history.push(data.url_2);
          }
        }}
        position={data.design2.position}
        started_at={data.started_at2}
      />
    </div>
  );
};

DoubleBanners.propTypes = {
  data: PropTypes.object,
  setProductModalData: PropTypes.func,
  showModal_visible: PropTypes.func
};

export default DoubleBanners;
